<template>
  <button v-if="show" class="back-button" @click="goBack">
    <i class="mdi mdi-chevron-left back-icon"></i>
    <span class="back-text">Atrás</span>
  </button>
</template>

<script>
export default {
  name: 'BackButton',
  computed: {
    show() {
      return this.$route.path !== '/inicio';
    }
  },
  methods: {
    goBack() {
      this.$router.back();
    }
  }
}
</script>

<style scoped>
.back-button {
  position: fixed;
  top: 16px;
  left: 16px;
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 8px;
  border: none;
  border-radius: 24px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.3);
  cursor: pointer;
  transition: background 0.2s, transform 0.1s;
  z-index: 1000;
}

.back-button:hover {
  background: rgba(0, 0, 0, 0.8);
  transform: translateY(-1px);
}

.back-icon {
  font-size: 20px;     /* tamaño del icono */
  margin-right: 6px;   /* espacio con el texto */
}

.back-text {
  font-size: 14px;
  font-weight: 500;
}
</style>
